import { render } from "./index.vue?vue&type=template&id=4d0e972b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4d0e972b&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0e972b"],['__file',"resources/js/pages/notes/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d0e972b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d0e972b', __exports__)) {
    console.log('reload')
    api.reload('4d0e972b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4d0e972b&scoped=true", () => {
    console.log('re-render')
    api.rerender('4d0e972b', render)
  })

}


export default __exports__